import React from 'react'
import PropTypes from 'prop-types'
import styled, { keyframes } from 'styled-components'
import _map from 'lodash/map'
import _isEmpty from 'lodash/isEmpty'

import { Flex, Container, Button } from './common'
import { color, ease } from '../globalStyles'
import { H5 } from './type'

const NavBar = styled.nav`
  background: white;
  padding: 0rem 0;
`
const fadeInUp = keyframes`
  from {
    opacity: .5;
    transform: translateY(-30%);
  }
  to {
    opacity: 1;
    transform: translateY(0%);
  }
`
const fadeIn = keyframes`
  from {
    opacity: .5;
  }
`
const FilterWrap = styled(Flex)`
  display: ${props => (props.isVisible ? 'flex' : 'none')};
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  background: white;
  animation: ${fadeInUp} 0.3s ${ease.popIn};
  z-index: 1;
`
const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1;
  animation: ${fadeIn} 0.3s ${ease.popIn};
`
const FilterContainer = styled(Container)`
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
`
const FilterRow = styled.div`
  & + * {
    margin-top: 1rem;
    padding-top: 1rem;
  }
  & ${H5} {
    margin: 0.25rem;
  }
`
const FilterButton = styled(Button)`
  margin: 0.25rem;
`
const HeaderButton = styled.button`
  cursor: pointer;
  font-weight: 600;
  border: none;
  outline: none;
  text-transform: uppercase;
  padding: 1rem 0;
  font-size: 1.2rem;
  letter-spacing: 0.05em;
`
const Footer = styled(Flex)`
  ${HeaderButton} {
    width: 100%;
    border-top: 2px solid ${color.lightGrey};
    padding-top: 1rem;
    padding-bottom: 1rem;
    background: white;

    &:hover,
    &:focus {
      background: ${color.lightGrey};
    }
  }
`

const SpeciesFilter = props => (
  <div>
    {props.isVisible && <Overlay isVisible={props.isVisible} />}
    <FilterWrap column alignStretch isVisible={props.isVisible}>
      <NavBar>
        <Container>
          <Flex justifyBetween>
            <HeaderButton onClick={props.toggleFilter}>Close</HeaderButton>

            <HeaderButton onClick={props.resetFilters}>Reset</HeaderButton>
          </Flex>
        </Container>
      </NavBar>
      <FilterContainer>
        {!_isEmpty(props.filters.categories) && (
          <FilterRow>
            <H5>Category</H5>
            {_map(props.filters.categories, (value, key) => (
              <FilterButton
                key={key}
                isPrimary={value}
                onClick={() =>
                  props.updateFilter('categories', { [key]: !value })
                }
                rounded
              >
                {key}
              </FilterButton>
            ))}
          </FilterRow>
        )}
        {!_isEmpty(props.filters.colours) && (
          <FilterRow>
            <H5>Colours</H5>
            {_map(props.filters.colours, (value, key) => (
              <FilterButton
                key={key}
                isPrimary={value}
                onClick={() => props.updateFilter('colours', { [key]: !value })}
                rounded
              >
                {key}
              </FilterButton>
            ))}
          </FilterRow>
        )}
        {!_isEmpty(props.filters.conservationStatus) && (
          <FilterRow>
            <H5>Conservation Status:</H5>
            {_map(props.filters.conservationStatus, (value, key) => (
              <FilterButton
                key={key}
                isPrimary={value}
                onClick={() =>
                  props.updateFilter('conservationStatus', { [key]: !value })
                }
                rounded
              >
                {key}
              </FilterButton>
            ))}
          </FilterRow>
        )}
      </FilterContainer>
      <Footer>
        <HeaderButton isPrimary onClick={props.toggleFilter}>
          Done
        </HeaderButton>
      </Footer>
    </FilterWrap>
  </div>
)

SpeciesFilter.propTypes = {
  toggleFilter: PropTypes.func.isRequired,
  updateFilter: PropTypes.func.isRequired,
  resetFilters: PropTypes.func.isRequired,
  filters: PropTypes.object,
  results: PropTypes.array,
  isVisible: PropTypes.bool
}

export default SpeciesFilter



// WEBPACK FOOTER //
// ./src/components/SpeciesFilter.js